import React, { lazy, Suspense } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';

// Everything below the hero is code-split so it doesn't compete with the
// hero/LCP for the browser's main thread on first paint.
const TaglineBanner = lazy(() => import('./components/sections/TaglineBanner').then(mod => ({
  default: mod.TaglineBanner
})));
const Problems = lazy(() => import('./components/sections/Problems').then(mod => ({
  default: mod.Problems
})));
const Solution = lazy(() => import('./components/sections/Solution').then(mod => ({
  default: mod.Solution
})));
const Volumes = lazy(() => import('./components/sections/Volumes').then(mod => ({
  default: mod.Volumes
})));
const Bonuses = lazy(() => import('./components/sections/Bonuses').then(mod => ({
  default: mod.Bonuses
})));
const ValueTable = lazy(() => import('./components/sections/ValueTable').then(mod => ({
  default: mod.ValueTable
})));
const PriceReveal = lazy(() => import('./components/sections/PriceReveal').then(mod => ({
  default: mod.PriceReveal
})));
const WhyItWorks = lazy(() => import('./components/sections/WhyItWorks').then(mod => ({
  default: mod.WhyItWorks
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const HowItWorks = lazy(() => import('./components/sections/HowItWorks').then(mod => ({
  default: mod.HowItWorks
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const Objections = lazy(() => import('./components/sections/Objections').then(mod => ({
  default: mod.Objections
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="3udknzzefn0bz">
      <div className="w-full min-h-full bg-cream font-body text-ink" data-id="element-1" data-mp="3ucjcjtti8btq">
        <main data-id="element-2" data-mp="d3mmvivk99nu">
          <Hero data-id="element-3" data-mp="d45t42bum9m1" />
          <Suspense fallback={null} data-id="element-4" data-mp="d2l9h7r2ob2y">
            <TaglineBanner data-id="element-5" data-mp="851kbcsu6dw8" />
            <Problems data-id="element-6" data-mp="86w6svjrae2f" />
            <Solution data-id="element-7" data-mp="86clr5yt79k6" />
            <Volumes data-id="element-8" data-mp="3gle7udba4tcj" />
            <Bonuses data-id="element-9" data-mp="3gkv2rx6q9zfx" />
            <ValueTable data-id="element-10" data-mp="3gmft1am0ew7z" />
            <PriceReveal data-id="element-11" data-mp="3glny8208l2ir" />
            <WhyItWorks data-id="element-12" data-mp="3bmbevr8kqdkx" />
            <Testimonials data-id="element-13" data-mp="3bn2y02kziiub" />
            <HowItWorks data-id="element-14" data-mp="3bnmjtudr9rdm" />
            <Guarantee data-id="element-15" data-mp="3bk720jsp648i" />
            <FAQ data-id="element-16" data-mp="3qaxs9nen4v9i" />
            <Objections data-id="element-17" data-mp="3qbfvx53mubrg" />
            <FinalCTA data-id="element-18" data-mp="3qbzd2jlgkw4f" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-19" data-mp="3lkr2vlcb16q7">
          <Footer data-id="element-20" data-mp="3ljpiurdb99wc" />
        </Suspense>
        <StickyCTA data-id="element-21" data-mp="3limqef0cazeb" />
      </div>
    </LazyMotion>;
}